/*
 * @Author: tager
 * @Date: 2022-06-06 16:45:35
 * @LastEditors: tager
 * @LastEditTime: 2022-06-14 17:43:19
 * @Description: file content
 */
// 按需加载antd-mobile（即使按需其Dialog组件的体积仍然较大）
import 'antd-mobile/es/global'
import React from 'react'
// import ReactDOM from 'react-dom/client'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
// 不使用用户session sdk需要值空、否则无法使用@weike/toolkit
;(window as any).Session = null

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
